import LandingContent from './LandingContent';

export default LandingContent;